export { default as AdminRegisterPage } from './pages/AdminRegisterPage';
export { default as AdminViewPage } from './pages/AdminViewPage';
export { default as AdminEditPage } from './pages/AdminEditPage';
